// Per-user display settings, kept in the browser (the language lives in i18n.js)
import m from './m.js'

const DEFAULTS = {
  cardLabels: true, // label pills on cards
  cardVscode: true, // "check out in VS Code" button on PR cards
  cardCopyBranch: true, // "copy branch name" button on PR cards
  cardLinks: true, // linked pull requests of issues, closed issues of PRs
  claudeCli: false, // "work on it with Claude Code" in the terminal (claude-cli:// link)
  claudeVscode: false, // the same in VS Code (Claude Code extension)
  hideIssuesWithPr: false, // issue cards whose open linked PR is on the board
  laneWidth: 'normal', // see LANE_WIDTHS
}

export const LANE_WIDTHS = { narrow: 260, normal: 320, wide: 400 }

function load() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem('settings')) }
  } catch {
    return { ...DEFAULTS }
  }
}

export const settings = load()

export function setSetting(key, value) {
  settings[key] = value
  try {
    localStorage.setItem('settings', JSON.stringify(settings))
  } catch {
    // storage unavailable (private mode, blocked): works without it
  }
  m.redraw()
}
